export function buildCls(classes: (string | undefined | Boolean)[]) {
  return classes.filter(Boolean).join(" ");
}
